import { apiClient } from "@/lib/api/client";
import { ApiError } from "@/lib/api/error";
import { HTTP_STATUS } from "@/lib/api/http-status";
import { getPath } from "@/lib/api/path";
import { createFileRoute, redirect } from "@tanstack/react-router";
import type { InvitationDetail } from "./-type";

export const Route = createFileRoute("/auth/invitation/$invitationCode/")({
  beforeLoad: async ({ params }) => {
    /**
     * 有効な招待コードかどうかをチェック
     * 有効な招待コードでない場合にはリダイレクト
     * NOTE: loader または beforeLoad でないとリダイレクトできない
     */
    const res = await apiClient.GET(
      getPath("/v2/invitations/{invitationCode}"),
      {
        params: {
          path: {
            invitationCode: params.invitationCode,
          },
        },
      },
    );

    if (!res.data) {
      const error = new ApiError(res.error);
      if (
        error.response?.statusCode === HTTP_STATUS.BAD_REQUEST ||
        error.response?.statusCode === HTTP_STATUS.NOT_FOUND
      ) {
        throw redirect({
          to: "/auth/sign-in",
          params: {
            error: "invitation_not_found",
          },
        });
      } else {
        throw new Error("Invitation is invalid");
      }
    }
  },
  loader: async ({ params }) => {
    const res = await apiClient.GET(
      getPath("/v2/invitations/{invitationCode}"),
      {
        params: {
          path: {
            invitationCode: params.invitationCode,
          },
        },
      },
    );

    if (!res.data) {
      throw new Error("Invitation not found");
    }

    return {
      invitation: {
        email: res.data?.email,
        givenName: res.data?.givenName,
        familyName: res.data?.familyName,
        middleName: res.data?.middleName,
      } satisfies InvitationDetail,
    };
  },
});
